//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    billOfLoads: [],
    searchRequest: {},
  },
  mutations: {
    updateBillOfLoadProblems(state, billOfLoads) {
      state.billOfLoads = billOfLoads;
    },
    updateSearchBillOfLoadProblemsRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadBillOfLoadProblems({ commit, state, getters }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

      requestToSend.driverGroups = getters.flatWithChildDriverGroups(requestToSend.driverGroups);

      if (requestToSend.etaAssignedStart && !requestToSend.etaAssignedEnd) {
        requestToSend.etaAssignedEnd = moment(requestToSend.etaAssignedStart).endOf('d').toDate();
      }

      if (requestToSend.pickUpStart && !requestToSend.pickUpEnd) {
        requestToSend.pickUpEnd = moment(requestToSend.pickUpStart).endOf('d').toDate();
      }

      //const result = await api.post('/api/w/billOfLoads', requestToSend);
      const result = await newAPIPost('/api/w/billOfLoads', requestToSend);
      commit('updateSearchBillOfLoadProblemsRequest', fallbackRequest);
      return commit('updateBillOfLoadProblems', result);
    },
    saveBillOfLoadProblems(store, request) {
      //return api.post('/api/w/billOfLoads/save', request);
      return newAPIPost('/api/w/billOfLoads/save', request);
    },
  },
  getters: {
    getBillOfLoadProblems: state => state.billOfLoads,
  },
};
